import React, { useEffect, useRef } from "react";
import { gsap } from 'gsap';
import jmk from "../assets/jmk.jpg";

const Hero = ({ onBookAppointment, heroRef }) => {
  useEffect(() => {
    if (heroRef.current) {
      const heroText = heroRef.current.querySelector('.hero-text');
      const heroImage = heroRef.current.querySelector('.hero-image');

      gsap.fromTo(
        heroText,
        { opacity: 0, y: 50 },
        { opacity: 1, y: 0, duration: 1, ease: 'power3.out', delay: 0.5 }
      );

      gsap.fromTo(
        heroImage,
        { opacity: 0 },
        { opacity: 1, duration: 1.5, ease: 'power3.out', delay: 0.2 }
      );
    }
  }, [heroRef]);

  return (
    <section className="grid grid-cols-1 lg:grid-cols-2 h-auto lg:h-[90vh] bg-hero-bg" ref={heroRef}>
      <div className="flex items-center justify-center p-4 md:p-12 text-center lg:text-left">
        <div className="hero-text max-w-[550px] mx-auto lg:mx-0">
          <h1 className="font-serif text-[clamp(2rem,6vw,4.5rem)] leading-[1.15] mb-8">A Legacy Woven. A Future Worn.</h1>
          <p className="text-[clamp(0.9rem,2vw,1.25rem)] leading-[1.7] mb-12 max-w-[500px] mx-auto lg:mx-0">
            The soul of Scotland, tailored for today. Commission your bespoke
            kilt, where timeless tradition meets modern artistry.
          </p>
          <button className="font-sans bg-gradient-to-b from-primary to-primary-dark text-white border-none py-[1.2rem] px-[3.5rem] text-[1.1rem] font-medium uppercase tracking-[1.5px] cursor-pointer transition-all duration-300 rounded transform translate-y-0 hover:from-primary-dark hover:to-primary hover:shadow-[0_8px_25px_rgba(0,0,0,0.3)] hover:-translate-y-1" onClick={onBookAppointment}>
            Begin Your Consultation
          </button>
        </div>
      </div>
      <div className="overflow-hidden h-[60vh] lg:h-full order-first lg:order-none">
        <div
          className="hero-image w-full h-full bg-cover bg-center"
          style={{ backgroundImage: `url(${jmk})` }}
        ></div>
      </div>
    </section>
  );
};

export default Hero;
